import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BRAND_ID_HEADER, OCP_APIM_SUBSCRIPTION_PARAM, X_HOHR_CLIENT_PLATFORM, X_HOHR_CLIENT_VERSION } from '../core.constants';
import { BRAND_ID } from '../config/brand.constants';
import { getClientInfo } from '@app/shared/utils/client-info.util';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  // Bypass the HTTP interceptor chain (HttpBackend) for translations. The endpoint is
  // public, but routing it through the Auth0 interceptor couples app startup to Auth0's
  // token state: with an expired refresh token, getTokenSilently throws `invalid_grant`
  // (which the interceptor does NOT treat as anonymous), so the request fails/hangs and
  // breaks APP_INITIALIZER — freezing the splash on native and hiding the login buttons
  // on web. Mirror loadConfigClient's manual headers since interceptors no longer run.
  private readonly handler = inject(HttpBackend);

  getTranslation(lang: string): Observable<Translation> {
    return from(getClientInfo()).pipe(
      switchMap(({ version, platform }) =>
        new HttpClient(this.handler).get<Translation>(
          `${environment.url.api}/config/client/language/${lang}/translation`,
          {
            headers: new HttpHeaders({
              [BRAND_ID_HEADER]: BRAND_ID,
              [X_HOHR_CLIENT_VERSION]: version,
              [X_HOHR_CLIENT_PLATFORM]: platform,
            }),
            params: new HttpParams().set(OCP_APIM_SUBSCRIPTION_PARAM, environment.ocpApimSubscriptionKey),
          }
        )
      )
    );
  }
}
